import Palette from '@naruto/bgdapp/src/base/theme/normal/default/Global/Palette';

export default {
  MuiButton: {
    styleOverrides: {
      root: {
        minWidth: '64px',
        minHeight: '0px',
        fontSize: '1rem',
        fontWeight: 400,
        boxShadow: 'none !important',
        borderRadius: '4px',
        textTransform: 'math-auto !important'
      },
      label: {
        fontWeight: 400
      },
      outlinedPrimary: {
        backgroundColor: Palette.info.light,
        '&:hover': {
          backgroundColor: Palette.info.light
        }
      },
      outlinedInherit: {
        borderColor: Palette.grey[400],
        backgroundColor: Palette.grey[700],
        '&:hover': {
          borderColor: Palette.grey[400],
          backgroundColor: Palette.grey[700]
        }
      },
      containedInherit: {
        color: Palette.text.primary,
        backgroundColor: Palette.grey[300],
        '&:hover': {
          backgroundColor: Palette.grey[300]
        }
      },
      containedPrimary: {
        color: Palette.primary.contrastText,
        backgroundColor: Palette.primary.main,
        '&:hover': {
          backgroundColor: Palette.primary.main
        }
      },
      containedSecondary: {
        color: Palette.text.contrast,
        backgroundColor: Palette.secondary.main,
        '&:hover': {
          backgroundColor: Palette.secondary.main
        }
      },
      textInherit: {
        color: '#000000'
      },
      textSecondary: {
        color: 'white'
      },
      containedSizeMedium: {
        minHeight: '40px'
      },
      containedSizeLarge: {
        minHeight: '48px'
      },
      outlinedSizeMedium: {
        minHeight: '40px'
      },
      outlinedSizeLarge: {
        minHeight: '48px'
      }
    }
  }
};
